import dynamic from 'next/dynamic';
import { Spinner } from 'components/Spinner';

const DynamicSkiRentalForm = dynamic(() => import('./Form'), { loading: () => <Spinner /> });

export default DynamicSkiRentalForm;
